import { fromAsync } from "../../async/static/fromAsync.js";
export const selectManyAsync = (source, selector) => {
    if (selector.length === 1) {
        return selectManyAsync1(source, selector);
    }
    else {
        return selectManyAsync2(source, selector);
    }
};
const selectManyAsync1 = (source, selector) => {
    async function* generator() {
        for (const value of source) {
            const innerValues = await selector(value);
            for (const innerValue of innerValues) {
                yield innerValue;
            }
        }
    }
    return fromAsync(generator);
};
const selectManyAsync2 = (source, selector) => {
    async function* generator() {
        let index = 0;
        for (const value of source) {
            const innerValues = await selector(value, index);
            for (const innerValue of innerValues) {
                yield innerValue;
            }
            index++;
        }
    }
    return fromAsync(generator);
};
